import { useEffect, useMemo, useRef } from 'react';
import { CustomerLocation } from '../common/types/models';

type CustomerLocationSelectProps = {
  customerLocations: CustomerLocation[];
  customerLocationId?: number | null;
  customerLocationOnChange: (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => void;
};

const CustomerLocationSelect = ({
  customerLocations,
  customerLocationId,
  customerLocationOnChange,
}: CustomerLocationSelectProps) => {
  const selectRef = useRef<HTMLSelectElement | null>(null);

  const locationsKey = useMemo(
    () => customerLocations.map(location => location.id).join(','),
    [customerLocations]
  );

  useEffect(() => {
    const selectElement = selectRef.current;

    if (!selectElement || customerLocations.length === 0) {
      return;
    }

    M.FormSelect.getInstance(selectElement)?.destroy();

    const instance = M.FormSelect.init(selectElement);

    return () => {
      if (M.FormSelect.getInstance(selectElement) === instance) {
        instance.destroy();
      }
    };
  }, [locationsKey, customerLocations.length]);

  return (
    <div
      id="customerLocationSelect"
      className="input-field col s3 right"
      style={{
        marginTop: '25px',
        marginRight: '20px',
        width: '330px',
        padding: '10px',
        paddingTop: '0',
      }}
    >
      <select
        id="customerLocationId"
        ref={selectRef}
        value={customerLocationId || customerLocations[0].id}
        onChange={customerLocationOnChange}
      >
        {customerLocations.map((cl: CustomerLocation) => (
          <option key={cl.id} value={cl.id}>
            {cl.name}
          </option>
        ))}
      </select>

      <label htmlFor="customerLocationId" style={{ color: 'black' }}>
        Customer Location (Pharmacy)
      </label>
    </div>
  );
};

export default CustomerLocationSelect;
